import { React } from '@api'
import { Utils} from '@tldraw/core'
import {useObserver} from 'mobx-react-lite'
import {getBoundsRectangle, DashStyle, useTldrawApp, FrameShape, FrameShapeStore} from '@modules/whiteboard'
import {TDShapeUtil} from '@modules/whiteboard/shapes/TDShapeUtil'
import {createDefaultStyle, transformRectangle, transformSingleRectangle} from '../shared'
import { FrameShapeComponent } from './FrameShapeComponent'

type T = FrameShape
type E = SVGSVGElement

export const FRAME_BOUNDS_PADDING = 8
export const FRAME_TITLE_HEIGHT = 32

export class FrameUtil extends TDShapeUtil<T, E> {
  type = 'frame' as const

  canBind = true

  getShape = (props: Partial<T>): T => {
    return Utils.deepMerge<T>(
      {
        id: 'id',
        type: 'frame',
        name: 'Frame',
        parentId: 'page',
        childIndex: 0,
        point: [0, 0],
        size: [50, 50],
        rotation: 0,
        style: {...createDefaultStyle(), strokeWidth: 1},
      },
      props
    )
  }

  Component = FrameShapeComponent as any

  Indicator = TDShapeUtil.Indicator<T>(({ shape }) => {
    return useObserver(() => {
      const {size: [width, height], id} = shape

      const sw = 1

      return (
        <rect
          x={sw}
          y={sw}
          rx={1}
          ry={1}
          width={Math.max(1, width - sw * 2)}
          height={Math.max(1, height - sw * 2)}
        />
      )
    })
  })

  getBounds = (shape: T) => {
    return getBoundsRectangle(shape)
  }

  shouldRender = (prev: T, next: T) => {
    return next.size !== prev.size || next.style !== prev.style
  }

  transform = transformRectangle

  transformSingle = transformSingleRectangle
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/frame/FrameUtil.tsx